import angular from 'angular';
import BackdropRailItemController from './bd-rail-item.controller';

import './bd-rail-item.styles.scss';

const Template = /* html */ `
  <div class="backdrop-rail-item" ng-show="$ctrl.item.selected">
    <div ng-transclude></div>
  </div>
`;

export const BackdropRailItemComponent = {
  selector: 'bdRailItem',
  require: {
    bdRailController: '^bdRail',
  },
  transclude: true,
  controller: BackdropRailItemController,
  template: Template,
  bindings: {
    title: '@',
    icon: '@',
    permission: '@?',
  },
};

export default angular.module('autoboard.backdropRaiItem', [])
  .component(BackdropRailItemComponent.selector, BackdropRailItemComponent)
  .name;
